import { PropsWithChildren } from 'react'

import BaseMobileModal from 'components/Modal/BaseMobileModal'
import theme from 'theme_'
import {
  FullscreenModalContent,
  FullscreenModalFooter,
  FullscreenModalFooterButton,
  FullscreenModalHeader,
} from './styles'
import { H5 } from 'components/Typography'
import { ModalCloseBtn } from '../styles'
import { Close as CloseIcon } from 'components/Icons'

interface FullscreenModalProps {
  isOpen: boolean
  onClose: VoidFunction
  headerTitle: string
  footerCloseText: string
  footerConfirmText: string
  onConfirm: VoidFunction
  disabledConfirm: boolean
}

function FullscreenModal({
  isOpen,
  onClose,
  headerTitle,
  footerCloseText,
  footerConfirmText,
  onConfirm,
  disabledConfirm,
  children,
}: PropsWithChildren<FullscreenModalProps>) {
  return (
    <BaseMobileModal
      backgroundColor={theme.colors.grey}
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <FullscreenModalHeader>
        <H5>{headerTitle}</H5>
        <ModalCloseBtn onClick={onClose}>
          <CloseIcon />
        </ModalCloseBtn>
      </FullscreenModalHeader>

      <FullscreenModalContent>{children}</FullscreenModalContent>

      <FullscreenModalFooter>
        <FullscreenModalFooterButton variant="secondary" onClick={onClose}>
          {footerCloseText}
        </FullscreenModalFooterButton>
        <FullscreenModalFooterButton
          disabled={disabledConfirm}
          variant="primary"
          onClick={onConfirm}
        >
          {footerConfirmText}
        </FullscreenModalFooterButton>
      </FullscreenModalFooter>
    </BaseMobileModal>
  )
}

export default FullscreenModal
